export default "__VITE_ASSET__B2v$0OJE__"